import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import questions from './store/module/questions';

Vue.use(Vuex);


export default new Vuex.Store({
  modules: {
    patientQuestion: questions
  },
  state: {
    messages: [],
    snackBarshow : false,
    snackBarType : "warning",
    snackBarmessage : "",
    isAuthorized : false,
    overlay : false,
    isPublic : true,
    user : {},
    messagesCount : 0,
  },
  getters : {
    getField,
    isLoggedIn: state => state.isAuthorized,
    hasPayed: state => state.hasPayed,
  },
  mutations: {
    updateField
  },
  actions: {

  }
});
